import { Receipt } from "lucide-react";
import { ExpenseReceipts } from "@/components/ExpenseReceipts";

export default function ManagerExpenses() {
  return (
    <div className="p-4 max-w-5xl mx-auto space-y-4">
      <div className="flex items-center gap-2">
        <Receipt className="h-5 w-5 text-[#1A2744]" />
        <h1 className="text-xl font-bold text-[#1A2744]">Expense receipts</h1>
      </div>
      <p className="text-xs text-gray-600">
        Upload GST receipts for purchases. Snap the receipt with your phone camera —
        admin will see it for review.
      </p>
      <ExpenseReceipts />
    </div>
  );
}
